import { useContext } from 'react';
import { ReagentContext } from '../contexts/ReagentContext';

export const useReagent = () => {
  const context = useContext(ReagentContext);
  if (context === null) {
    throw new Error('useReagent must be used within a ReagentProvider');
  }
  return context;
};